import {createRouter, createWebHashHistory, createWebHistory} from "vue-router";
import LandingToDo from "@/console-new/views/landing/ToDo.vue";
import OpsContainer from "@/console-new/views/ops/OpsContainer.vue";
import PluginsContainer from "@/console-new/views/plugins/PluginsContainer.vue";
import PluginsMarketplace from "@/console-new/views/plugins/PluginsMarketplace.vue";
import PluginsDelivery from "@/console-new/views/plugins/PluginsDelivery.vue";
import PluginsTakeaway from "@/console-new/views/plugins/PluginsTakeaway.vue";
import PluginsPos from "@/console-new/views/plugins/PluginsPos.vue";
import PluginsKitchen from "@/console-new/views/plugins/PluginsKitchen.vue";
import ConfigContainer from "@/console-new/views/config/ConfigContainer.vue";
import MenuContainer from "@/console-new/views/config/MenuContainer.vue";
import QrCodeContainer from "@/console-new/views/config/QrCodeContainer.vue";
import AdministrationContainer from "@/console-new/views/config/AdministrationContainer.vue";
import PrintersContainer from "@/console-new/views/config/PrintersContainer.vue";
import GeneralSettingsContainer from "@/console-new/views/config/settings/GeneralSettingsContainer.vue";
import CounterSettingsContainer from "@/console-new/views/config/settings/CounterSettingsContainer.vue";
import PaymentsSettingsContainer from "@/console-new/views/config/settings/PaymentsSettingsContainer.vue";
import FeaturesSettingsContainer from "@/console-new/views/config/settings/FeaturesSettingsContainer.vue";
import MenuSettingsContainer from "@/console-new/views/config/settings/MenuSettingsContainer.vue";
import SettingsContainer from "@/console-new/views/config/settings/SettingsContainer.vue";
import AnalyticsContainer from "@/console-new/views/analytics/AnalyticsContainer.vue";
import ViewsContainer from "@/console-new/views/analytics/ViewsContainer.vue";
import OrdersContainerAnalytics from "@/console-new/views/analytics/OrdersContainer.vue";
import OrdersContainerOps from "@/console-new/views/ops/OrdersContainer.vue";
import TablesContainerOps from "@/console-new/views/ops/TablesContainer.vue";
import TablesView from "@/console-new/components/ops/tables/TablesView.vue";
import OpsReservationsContainer from "@/console-new/views/ops/ReservationsContainer.vue";
import TablesContainer from "@/console-new/views/analytics/TablesContainer.vue";
import ProductsContainer from "@/console-new/views/analytics/ProductsContainer.vue";
import CounterSalesContainer from "@/console-new/views/ops/CounterSalesContainer.vue";
import ShopContainer from "@/console-new/views/plugins/ShopContainer.vue";
import NewBusinessContainer from "@/console-new/views/NewBusinessContainer.vue";
import LostView from "@/console-new/views/LostView.vue";
import CouponsContainer from "@/console-new/views/config/CouponsContainer.vue";
import WarehouseContainer from "@/console-new/views/config/WarehouseContainer.vue";
import ReservationsContainer from "@/console-new/views/plugins/reservations/ReservationsContainer.vue";
import ReservationsExperiences from "@/console-new/views/plugins/reservations/ReservationsExperiences.vue";
import ReservationsSettings from "@/console-new/views/plugins/reservations/ReservationsSettings.vue";
import StripeTablesContainer from "@/console-new/views/config/administrations/StripeTablesContainer.vue";
import QromoTablesContainer from "@/console-new/views/config/administrations/QromoTablesContainer.vue";
import TaxationTablesContainer from "@/console-new/views/config/administrations/TaxationTablesContainer.vue";
import CardsContainer from "@/console-new/views/config/administrations/CardsContainer.vue";
import MarketingContainer from "@/console-new/views/marketing/MarketingContainer.vue";
import NewsletterContainer from "@/console-new/views/marketing/NewsletterContainer.vue";
import CampaignsContainer from "@/console-new/views/marketing/CampaignsContainer.vue";
const routes = [
	{
		path: "/",
		component: LandingToDo
	},
	{
		path: "/ops",
		component: OpsContainer,
		children: [
			{
				path: "orders",
				component: OrdersContainerOps
			},
			{
				path: "tables",
				component: TablesContainerOps,
				children: [
					{
						path: "",
						component: TablesView
					},
					{
						path: "reservations",
						component: OpsReservationsContainer
					},
				]
			},
			{
				path: "counter",
				component: CounterSalesContainer
			},
		]
	},
	{
		path: "/analytics",
		component: AnalyticsContainer,
		children: [
			{
				path: "views",
				component: ViewsContainer
			},
			{
				path: "orders",
				component: OrdersContainerAnalytics
			},
			{
				path: "tables",
				component: TablesContainer
			},
			{
				path: "products",
				component: ProductsContainer
			},
		],
	},
	{
		path: "/marketing",
		component: MarketingContainer,
		children: [
			{
				path: "newsletter",
				component: NewsletterContainer
			},
			{
				path: "campaigns",
				component: CampaignsContainer
			},
			{
				path: "coupons",
				component: CouponsContainer
			}
		],
	},
	{
		path: "/config",
		component: ConfigContainer,
		children: [
			{
				path: "menu",
				component: MenuContainer
			},
			{
				path: "qrcode",
				component: QrCodeContainer
			},
			{
				path: "administration",
				component: AdministrationContainer,
				children: [
					{
						path: "stripe",
						component: StripeTablesContainer,
						children: [
							{
								path: "dashboard",
								component: StripeTablesContainer
							}
						]
					},
					{
						path: "qromo",
						component: QromoTablesContainer
					},
					{
						path: "taxation",
						component: TaxationTablesContainer
					},
					{
						path: "cards",
						component: CardsContainer
					}
				]
			},
			{
				path: "settings",
				component: SettingsContainer,
				children: [
					{
						path: "general",
						component: GeneralSettingsContainer
					},
					{
						path: "counter",
						component: CounterSettingsContainer
					}
				]
			},
			{
				path: "devices",
				component: SettingsContainer,
				children: [
					{
						path: "pos",
						component: PluginsPos
					},
					{
						path: "printers",
						component: PrintersContainer,
					},
				]
			},
			{
				path: "warehouse",
				component: WarehouseContainer,
			}
		]
	},
	{
		path: "/plugins",
		component: PluginsContainer,
		children: [
			{
				path: "shop",
				component: ShopContainer,
				children: [
					{
						path: ":itemId",
						component: ShopContainer,
					}
				]
			},
			{
				path: "menu",
				component: MenuSettingsContainer
			},
			{
				path: "orders",
				component: SettingsContainer,
				children: [
					{
						path: "features",
						component: FeaturesSettingsContainer,
					},
					{
						path: "payments",
						component: PaymentsSettingsContainer,
					}
				]
			},
			{
				path: "reservations",
				component: ReservationsContainer,
				children: [
					{
						path: "experiences",
						component: ReservationsExperiences,
					},
					{
						path: "settings",
						component: ReservationsSettings,
					}
				]
			},
			{
				path: "delivery",
				component: PluginsDelivery
			},
			{
				path: "takeaway",
				component: PluginsTakeaway
			},
			{
				path: "kitchen",
				component: PluginsKitchen
			},
			{
				path: "marketplace",
				component: PluginsMarketplace
			},
		]
	},
	{
		path: "/add-business",
		component: NewBusinessContainer
	},
	{
		path: "/lost",
		component: LostView
	},
];

const router = createRouter({
	history: import.meta.env.VITE_HISTORY_MODE === 'web' ? createWebHistory('/console/new/') : createWebHashHistory('/console/new/'),
	base: '/console/new/',
	routes,
});

export default router;